module.exports = __webpack_public_path__ + "01ea978f/img/boston-lights.a623432f.png";